import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';

const SIDEBAR_W = 210;
const STICKY_TOP = 112; // navbar (56) + subnav (48) + gap (8)

export default function ThreeColumnLayout({ left, center, right }) {
  const theme = useTheme();
  const showSidebars = useMediaQuery(theme.breakpoints.up('lg'));
  const showRight = useMediaQuery(theme.breakpoints.up('md'));

  if (!showSidebars) {
    return (
      <Box>
        {/* Mobile: center (news) first, then left (standings), then right (games) */}
        <Box sx={{ mb: 3 }}>{center}</Box>
        <Box sx={{ display: 'flex', gap: 2, flexDirection: showRight ? 'row' : 'column' }}>
          <Box sx={{ flex: 1, minWidth: 0,
            backgroundColor: 'rgba(8,18,32,0.6)', border: '1px solid #1a2e44',
            borderRadius: 2, p: 1.5 }}>
            {left}
          </Box>
          <Box sx={{ flex: 1, minWidth: 0,
            backgroundColor: 'rgba(8,18,32,0.6)', border: '1px solid #1a2e44',
            borderRadius: 2, p: 1.5 }}>
            {right}
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
      {/* Left sidebar */}
      <Box sx={{
        width: SIDEBAR_W, flexShrink: 0,
        position: 'sticky', top: STICKY_TOP,
        maxHeight: `calc(100vh - ${STICKY_TOP + 16}px)`, overflowY: 'auto',
        backgroundColor: 'rgba(8,18,32,0.6)', border: '1px solid #1a2e44',
        borderRadius: 2, p: 1.5,
        '&::-webkit-scrollbar': { width: 3 },
        '&::-webkit-scrollbar-thumb': { background: 'rgba(245,166,35,0.25)', borderRadius: 2 },
      }}>
        {left}
      </Box>

      {/* Center — news */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {center}
      </Box>

      {/* Right sidebar */}
      <Box sx={{
        width: SIDEBAR_W, flexShrink: 0,
        position: 'sticky', top: STICKY_TOP,
        maxHeight: `calc(100vh - ${STICKY_TOP + 16}px)`, overflowY: 'auto',
        backgroundColor: 'rgba(8,18,32,0.6)', border: '1px solid #1a2e44',
        borderRadius: 2, p: 1.5,
        '&::-webkit-scrollbar': { width: 3 },
        '&::-webkit-scrollbar-thumb': { background: 'rgba(245,166,35,0.25)', borderRadius: 2 },
      }}>
        {right}
      </Box>
    </Box>
  );
}
